import React from "react";
import "./Hero.css";

function Hero() {
  return (
    <section className="hero" id="top">
      <div className="container hero-content">
        <div className="hero-copy">
          <p className="hero-eyebrow">Conseil informatique · Paris</p>
          <h2 className="hero-title animate-fade-in">
            Le numérique, pensé pour votre activité.
          </h2>
          <p className="hero-subtitle animate-fade-in delay-1">
            Conseil en systèmes et logiciels informatiques, au plus près de vos besoins.
          </p>
          <a href="#contact" className="btn btn-primary animate-fade-in delay-2">
            Échangeons sur votre projet <span aria-hidden="true">↗</span>
          </a>
        </div>
        <div className="hero-visual" aria-hidden="true">
          <div className="hero-visual-grid"></div>
          <img src="/logo.png" alt="" className="hero-mark" />
          <p>Systèmes<br />Logiciels<br />Conseil</p>
          <span className="hero-visual-index">HIA / 01</span>
        </div>
      </div>
    </section>
  );
}

export default Hero;
